import { render, staticRenderFns } from "./exchangeCoupon.vue?vue&type=template&id=c2189898&scoped=true&"
import script from "./exchangeCoupon.vue?vue&type=script&lang=js&"
export * from "./exchangeCoupon.vue?vue&type=script&lang=js&"
import style0 from "./exchangeCoupon.vue?vue&type=style&index=0&id=c2189898&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2189898",
  null
  
)

export default component.exports